// @deprecated
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Caption, Subtitle, BodyCopy } from 'components/Text'
import Cluster from 'components/Cluster'
import Spacer from 'components/Spacer'
import SideAnchor from 'components/SideAnchor'

import { useStepContext } from './Context'

const Wrapper = styled.div``

const StyledCluster = styled(Cluster)`
	position: relative;
`

const Tag = styled(Caption).attrs({ as: 'div' })`
	min-width: 1.55em;
	padding: 0.25em 0.75em;
	line-height: 1.25rem !important;
	display: flex;
	align-items: center;
	justify-content: center;
	background: var(--color-lighterGrey);
	color: var(--color-black);
	text-align: center;
	border-radius: 28px;
	min-width: 1.625rem;
	vertical-align: middle;
	transition: 0.2s all ease-out;
`

const StepNumber = styled(Tag)`
	padding: 0.25em 0.5em;
	${p => p.theme.above('lg')`
    position: absolute;
    right: 100%;
		${StyledCluster}:hover &, ${StyledCluster}:focus-within & {
			background: transparent;
			color: var(--color-lighterGrey);
		}
  `}
`

const StyledSideAnchor = styled(Subtitle).attrs({ as: SideAnchor })`
	display: none;
	${p => p.theme.above('lg')`
		display: inline-block;
		padding: 0.25rem 0.5rem;
  	position: absolute;
		right: 100%;
		margin: 0 -0.175rem 0 0;
		z-index: 1;
		opacity: 0;
		${StyledCluster}:hover & {
			opacity: 1;
		}
  `}
`

const ArticleStep = ({ heading, title, children, optional, number, as = 'section', className }) => {
	const { step, slug } = useStepContext({ skip: optional || number })
	const id = slug(title)
	return (
		<Wrapper as={as} id={id} className={className}>
			{!!heading && <BodyCopy color='gray'>{heading}</BodyCopy>}
			<Spacer.V xs={1} />
			<StyledCluster xs={0.5} align='center'>
				<StyledSideAnchor parent={StyledCluster} id={id} />
				{!optional && <StepNumber>{number || step}</StepNumber>}
				<Subtitle as='h3'>{title}</Subtitle>
				{optional && <Tag>Optional</Tag>}
			</StyledCluster>
			<Spacer.V margin xs={-1.5} />
			{children}
		</Wrapper>
	)
}

ArticleStep.propTypes = {
	heading: PropTypes.string,
	title: PropTypes.string,
	optional: PropTypes.bool,
	number: PropTypes.node,
	as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
}

export default ArticleStep
